import React, { useEffect, useRef, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import FullWidthButton from "../components/buttons/FullWidthButton";

const CipoForma = () => {
	const { order, updateOrder } = useOrder();
	const navigate = useStepNavigate();
	const { saveOrder, loading: orderSaveLoading } = useOrderSave();

	const handleAnswer = async (answer) => {
		try {
			const updatedOrder = {
				...order,
				hmeliorder: {
					...order.hmeliorder,
					hmeliorder_is_hightopshoes: answer
				}
			};
			updateOrder(updatedOrder);
			const result = await saveOrder(updatedOrder);

			if (result.success) {
				navigate('/ModellValaszto');
			}
		} catch (error) {
			console.error("Hiba a rendelés mentésekor:", error);
		}
	};

	return (
		<TablerLayout title="Kérem, válassza ki a cipő formáját:">
			<div className="row justify-content-center">
				<div className="col-md-10 mb-4">
					<div className="card-body text-center">
						<h5 className="mb-3 text-start"></h5>
						<div className="row g-4 justify-content-center">
							<div className="col-12 col-md-6 d-flex justify-content-center">
								<button
									type="button"
									className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold ${order.hmeliorder?.hmeliorder_is_hightopshoes === 0 ? 'btn-primary' : 'btn-outline-primary'}`}
									style={{ fontSize: 22 }}
									onClick={() => handleAnswer(0)}
									disabled={orderSaveLoading}
								>
									Félcipő
								</button>
							</div>
							<div className="col-12 col-md-6 d-flex justify-content-center">
								<button
									type="button"
									className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold ${order.hmeliorder?.hmeliorder_is_hightopshoes === 1 ? 'btn-primary' : 'btn-outline-primary'}`}
									style={{ fontSize: 22 }}
									onClick={() => handleAnswer(1)}
									disabled={orderSaveLoading}
								>
									Magasszárú
								</button>
							</div>
						</div>
					</div>
					<div className="d-flex justify-content-between mt-4">
						<StepperNavButton
							side="left"
							label="Vissza"
							onClick={() => navigate('/Kerdesek')}
							disabled={orderSaveLoading}
						/>
					</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default CipoForma;